module.exports = __webpack_public_path__ + "static/media/deleteFromHome.2a771922.svg";